<template>
  <!-- 自动化生产线 -->
  <div class="autoline">
    <div style="margin-bottom:1rem;">
      <el-button @click="add" size="small" type="success">添加</el-button>
      <el-button @click="save" size="small" type="primary">保存数据</el-button>
    </div>
    <div v-for="(item,i) in tableData" :key="i" class="item">
      <el-form label-width="6rem">
        <el-form-item label="生产线照片">
          <el-upload class="avatar-uploader" action="" :http-request="(e)=>{uploadfile(e,i)}" :show-file-list="false">
            <img v-if="item.beltlineImg" :src="item.beltlineImg" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <i @click="del(item,i)" style="
            position: absolute;
            top: 0;
            right: 0;
            font-size: 1.2rem;
            color: #f00;
            font-weight: 600;
            cursor: pointer;" class=" el-icon-remove-outline"></i>
          <!-- <el-button class="undock" type="warning">移除</el-button> -->
        </el-form-item>
        <el-form-item label="生产线名称">
          <el-input maxlength="10" show-word-limit v-model="item.beltlineName"></el-input>
        </el-form-item>

        <el-form-item label="生产线介绍">
          <el-input maxlength="200" show-word-limit type="textarea" :rows="3" v-model="item.remark"></el-input>

        </el-form-item>
      </el-form>
    </div>
  </div>

</template>

<script>
import api from '@/apis/produce/autoline'
import upapi from '@/apis/upload'
export default {
  data() {
    return {

      tableData: [
        {
          beltlineName: '', //名称
          beltlineImg: '', //照片
          remark: '', //介绍
        },
      ],
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    getlist(){
    api
      .list({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.tableData = res.data.list
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    add() {
      this.tableData.unshift({
        beltlineName: '', //名称
        beltlineImg: '', //照片
        remark: '', //介绍
      })
    },
    del(item, i) {
      this.$confirm(`确定删除数据？`).then(() => {
        if (item.id) {
          
          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.getlist()
              this.$message.success(res.message)
              this.tableData.splice(i, 1)
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.tableData.splice(i, 1)
        }
      })
    },

    save() {
      api.save(this.tableData).then((res) => {
        if (res.code === 10000) {
          this.getlist()
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //上传图片
    uploadfile(val, i) {
      // console.log(val, i)

      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.tableData[i].beltlineImg = res.data
          // this.$message.success(res.message)
          this.save()
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.autoline { padding-top: 10px;
  .item{ display:inline-block; border: #3570ff solid 1px; position: relative; width: 45%; padding:1rem; margin-right:1rem; margin-bottom: 1rem;
    .el-form-item{ margin-bottom: 15px;}
  }
}
</style>